<template>
  <div class="css-grid battery-order-view__row battery-order-view__row--header">
    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell battery-order-view__cell--header">Battery Line</div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell battery-order-view__cell--header">Battery Size</div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell battery-order-view__cell--header">Pack Size</div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell battery-order-view__cell--header">Quantity Description</div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell battery-order-view__cell--header">Imprint</div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell battery-order-view__cell--header h-center-align">Quantity</div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell battery-order-view__cell--header h-center-align">Subtotal</div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell battery-order-view__cell--header">&nbsp;</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProductHeader',
  };
</script>
